import Icon from '../components/Icon.vue'

Icon.register({
  music: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M512 32l0 352c0 35.3-43 64-96 64s-96-28.7-96-64 43-64 96-64c11.3 0 22 1.5 32 3.9v-184.6l-256 75v233.7c0 35.3-43 64-96 64s-96-28.7-96-64 43-64 96-64c11.3 0 22 1.5 32 3.9v-261.4c0-14 9.1-26.3 22.4-30.5l320-94.5c20.5-6.5 41.6 8.8 41.6 30.5z'
      }
    ]
  }
})
